import React, { useState } from "react";
import { LogoMark } from "./Logo";
import { COMPANY } from "@/lib/data";
import LegalModal from "./LegalModal";
import LegalDocsModal from "./LegalDocsModal";

export default function Footer() {
  const [legalOpen, setLegalOpen] = useState(false);
  const [cgvOpen, setCgvOpen] = useState(false);
  const [privacyOpen, setPrivacyOpen] = useState(false);
  return (
    <footer className="bg-[#0F172A] text-[#fdfbf7]" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 pt-16 pb-8">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <LogoMark size={44} />
              <div>
                <div className="font-serif-display text-2xl">HM Conseil Digital</div>
                <div className="font-mono-tech text-[10px] uppercase tracking-[0.22em] text-[#fdfbf7]/50 mt-1">
                  HMCD · Solaire · Isolation · Rénovation
                </div>
              </div>
            </div>
            <p className="mt-6 text-[15px] text-[#fdfbf7]/70 max-w-md leading-relaxed">
              Énergie solaire et rénovation énergétique en Île-de-France.
              Depuis {COMPANY.founded}, nous accompagnons particuliers et
              professionnels dans leur transition.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="font-mono-tech text-[10px] uppercase tracking-[0.22em] text-[#fdfbf7]/50 mb-4">
              Contact
            </div>
            <ul className="space-y-2 text-[15px]">
              <li>
                <a href={`tel:${COMPANY.phoneRaw}`} data-testid="footer-phone" className="hover:text-[#FF9800] transition-colors">
                  {COMPANY.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${COMPANY.email}`} className="hover:text-[#FF9800] transition-colors">
                  {COMPANY.email}
                </a>
              </li>
              <li className="text-[#fdfbf7]/70 mt-3">
                {COMPANY.address}<br />
                {COMPANY.city}
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="font-mono-tech text-[10px] uppercase tracking-[0.22em] text-[#fdfbf7]/50 mb-4">
              Navigation
            </div>
            <ul className="space-y-2 text-[15px]">
              {[
                ["solutions", "Solutions"],
                ["mission", "Notre approche"],
                ["partenaires", "Partenaires"],
                ["contact", "Contact"],
              ].map(([id, label]) => (
                <li key={id}>
                  <button
                    data-testid={`footer-nav-${id}`}
                    onClick={() =>
                      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })
                    }
                    className="text-[#fdfbf7]/80 hover:text-[#FF9800] transition-colors"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="font-mono-tech text-[10px] uppercase tracking-[0.22em] text-[#fdfbf7]/50 mb-4">
              Certifications
            </div>
            <ul className="space-y-2 text-[13px] text-[#fdfbf7]/70">
              <li>RGE QualiPV</li>
              <li>Qualibat 7141</li>
              <li>Décennale AXA</li>
              <li>MaPrimeRénov'</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 border-t border-[#fdfbf7]/10 pt-8 flex flex-wrap items-center justify-between gap-4">
          <div className="text-xs text-[#fdfbf7]/50">
            © {new Date().getFullYear()} {COMPANY.name}. Tous droits réservés.
          </div>
          <div className="flex items-center gap-6 text-xs text-[#fdfbf7]/50">
            <button
              data-testid="footer-legal-btn"
              onClick={() => setLegalOpen(true)}
              className="hover:text-[#fdfbf7] transition-colors"
            >
              Mentions légales
            </button>
            <button
              data-testid="footer-cgv-btn"
              onClick={() => setCgvOpen(true)}
              className="hover:text-[#fdfbf7] transition-colors"
            >
              CGV
            </button>
            <button
              data-testid="footer-privacy-btn"
              onClick={() => setPrivacyOpen(true)}
              className="hover:text-[#fdfbf7] transition-colors"
            >
              Politique de confidentialité
            </button>
          </div>
        </div>

        {/* Massive brand wordmark */}
        <div className="mt-14 select-none overflow-hidden">
          <div className="font-serif-display text-[22vw] leading-none text-[#fdfbf7]/[0.045] tracking-tight text-center">
            HMCD
          </div>
        </div>
      </div>

      <LegalModal open={legalOpen} onClose={() => setLegalOpen(false)} />
      <LegalDocsModal type="cgv" open={cgvOpen} onClose={() => setCgvOpen(false)} />
      <LegalDocsModal type="privacy" open={privacyOpen} onClose={() => setPrivacyOpen(false)} />
    </footer>
  );
}
